module["exports"] = [
  "###-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/address/postcode.js
// module id = 1001
// module chunks = 0